import { render, staticRenderFns } from "./AccountMenuEntry.vue?vue&type=template&id=bdb908d2&scoped=true"
import script from "./AccountMenuEntry.vue?vue&type=script&lang=ts"
export * from "./AccountMenuEntry.vue?vue&type=script&lang=ts"
import style0 from "./AccountMenuEntry.vue?vue&type=style&index=0&id=bdb908d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb908d2",
  null
  
)

export default component.exports